import type { StatsigOptions } from '@statsig/react-bindings';

export function getStatsigProxyConfig(environment: string): StatsigOptions['networkConfig'] | undefined {
  if (environment !== 'staging') return undefined;

  const baseUrl = 'https://growtherapystaging.com/statsig';
  return {
    api: baseUrl,
    initializeUrl: `${baseUrl}/grow-config`,
    logEventUrl: `${baseUrl}/grow-analytics`,
  };
}
